// @ts-nocheck
import React from 'react';
import {
  AutoSizer, CellMeasurer, CellMeasurerCache, List, ListRowProps,
} from 'react-virtualized';
import './VirtualList.css';

/* Если в List нужно передать что-то типа className, разверни коммент
  Можно передавать все атрибуты, содержащиеся в List, или даже перезаписать,
  которые уже прописаны,
  например, нужны дополнительно className и высоту фиксированную
   Прописать можно так:
   export function  VirtualList({ data, row, ...rest })
   <List
    ... // уже прописанные атрибуты
    {...rest} // прописать обязательно в конце
   >
   А при вызове уже дополнительно вписать className и высоту
   <VirtualList
     data={table}
     row={RowTable}
     className="my-style"
     height={200}
   />
   P.s: Не уверена, что нужен react.memo, но на всякий случай пусть будет
*/
/**
 * Компонент-обертка для List из react-virtulized. Она позволяет нормально
 * ресайзить как сам список так и его строки при уменьшении размера экрана.
 * Позволяет не писать куча повторного кода в виде прописи кэша, рендера строки с оберткой,
 * автозайзер, с прописью высоты. Если нам нужен Header, то смотреть пример в Observation.Regular.js Или обратитесь к карасику)))
 * @param {Array} data массив данных, который должен отрисовыватсья
 * @param {JSX|Function} row то как должна отрисовываться строка в списке,
 * Обратно в row передается (item,index,array):
 * > item = data[index] - итем, который отрисовывается
 * > index = index - индекс тема, который отрисовывается
 * > array = data - массив данных, который должен отрисовыватсья
 */
// export function VirtualList({ data, row }) {
export const VirtualList = React.memo(
  ({ data, row }: any) => {
    const cacheRef = new CellMeasurerCache({
      defaultHeight: 50,
      fixedWidth: true,
    });
    // console.log(`%c VirtualList`, 'color: red');
    // listener debounce resize - с этой штукой кажется, будто подлагивает. крч не работает с ней должным образом
    // React.useEffect(() => {
    //   const resizeHandler = () => {
    //     console.log(`%c resize`, 'color: red');
    //     cacheRef.clearAll();
    //   }
    //   window.addEventListener('resize', debounce(resizeHandler, 500));
    //   return () => window.removeEventListener('resize', debounce(resizeHandler, 500));
    // }, []);
    function renderRow({
      index, key, parent, style,
    }: ListRowProps) {
      return (
        <CellMeasurer
          key={key}
          cache={cacheRef}
          parent={parent}
          columnIndex={0}
          rowIndex={index}
        >
          <div style={{ ...style }}>
            {row(data[index], index, data)}
          </div>
        </CellMeasurer>
      );
    }

    return (
      <div style={{ height: '100%' }}>
        <AutoSizer onResize={() => cacheRef.clearAll()}>
          {
          ({ width, height }) => (
            <List
              className="virtualized-outline"
              rowCount={data?.length || 0}
              width={width}
              height={height}
              style={{ overflowY: 'scroll' }}
              deferredMeasurementCache={cacheRef}
              rowHeight={cacheRef.rowHeight}
              rowRenderer={renderRow}
            // eslint-disable-next-line react/jsx-props-no-spreading
            // {...rest}
            />
          )
        }
        </AutoSizer>
      </div>
    );
  },
);

VirtualList.displayName = 'VirtualList';
